/* eslint-disable */
import React, { useEffect, useState } from 'react'
import Flex from 'typescript-styled-flex'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { FullScreenLoader } from '../../components/Loader'
import { is } from '../../components/MediaQuery'
import useSize from '../../hooks/useSize'
import PageWrapper from '../../components/Template/PageWrapper'
import PageWidget from '../../components/Template/PageWidget'
import { Loader } from '../../components/Loader/CalendarLoader'
import { default as IntegrationAirbnbComponent } from '../../containers/IntegrationAirbnb/IntegrationAirbnb'
import {
  getAirbnbChecked,
  getAirbnbListings,
  getAirbnbLoadingListing,
  getAirbnbStatus,
  getAirbnbSync,
  getAirbnbTab,
} from '../../reducers/airbnb/selectors'
import { IntegrationSync } from '../../reducers/airbnb'
import {
  getAirbnbIntegration,
  setAirbnbTab,
  toggleAirbnbNotAllModal,
} from '../../actions/airbnb'
import { isLicenseValid } from '../../reducers/userAccount/selectors/license'
import { IStore } from '../../reducers'
import { isUserNewPackage, isUserNewPremium } from '../../reducers/userAccount/selectors/userAccount'
import { Mixpanel } from '../../utils/Mixpanel'

export enum IntegrationRedirectReason {
  OldPriceList,
  NoLicenseValid,
  NoSyncing,
  NoVisitedYet,
}

function IntegrationAirbnb({ errMessage, isSaving, history, mobile, ...rest }) {
  const isDesktop = is.desktop()
  const { t } = useTranslation()
  const size = useSize('settings')
  const dispatch = useDispatch()
  const status = useSelector(getAirbnbStatus)
  const checked = useSelector(getAirbnbChecked)

  const tab = useSelector(getAirbnbTab)
  const listings = useSelector(getAirbnbListings)
  const sync = useSelector(getAirbnbSync)
  const licenseValid = useSelector(isLicenseValid)
  const newPremium = useSelector(isUserNewPackage)
  const oldPremium = useSelector(isUserNewPremium)
  const [disableCheck, setDisableCheck] = useState(false)
  const laccount = useSelector(
    (state: IStore) => state.userAccount.license.isLoading,
  )

  const luser = useSelector((state: IStore) => !state.userAccount.user.email)

  const aloading = useSelector(getAirbnbLoadingListing)

  const loading = laccount || aloading || luser

  useEffect(() => {
    setDisableCheck(false)
  }, [])

  const noConnected = listings.every(l => !l.bedbooking_id_room)

  const notEveryConnected = listings.every(l => !!l.bedbooking_id_room)

  useEffect(() => {
    const time = setTimeout(
      () => Mixpanel.track('Airbnb Screen View', {}),
      2000,
    )
    const goToInfo = (reason: IntegrationRedirectReason) => {
      clearTimeout(time)
      history.replace({
        pathname: `/integration/airbnb-info`,
        search: mobile ? '?mobile=1' : '',
        state: { reason },
      })
    }

    const params = new URLSearchParams(history.location.search)

    let code = params.get('code')

    if (!loading && !code) {
      if (newPremium && !licenseValid) {
        history.replace({
          pathname: '/upgrade',
          state: { },
        })
        return
      }
      //Użytkownik znajduje się na nowym planie cenowym i nie ma wykupionego pakietu Premium.
      if (oldPremium && !licenseValid && noConnected) {
        return goToInfo(IntegrationRedirectReason.NoLicenseValid)
      }

      // if (
      //   sync === IntegrationSync.NotSyncing &&
      //   !disableCheck &&
      //   !(history.location.state && history.location.state.force)
      // ) {
      //   return goToInfo(IntegrationRedirectReason.NoSyncing)
      // }
    }
  }, [
    sync,
    newPremium,
    oldPremium,
    disableCheck,
    noConnected,
    status,
    checked,
    loading,
    licenseValid,
  ])

  const goTo = () => {
    history.push('/')
  }

  const goToSync = () => {
    if (!notEveryConnected && sync === IntegrationSync.NotSyncing) {
      dispatch(toggleAirbnbNotAllModal(true))
    } else {
      dispatch(setAirbnbTab(2))
    }
  }

  useEffect(() => {
    dispatch(getAirbnbIntegration())
  }, [dispatch])

  return (
    <Flex
      justifyStart={true}
      alignStart={true}
      column={true}
      style={{
        marginTop: mobile ? 0 : '1.5em',
        overflow: 'hidden',
        width: '100%',
      }}
    >
      <React.Suspense fallback={<FullScreenLoader />}>
        <PageWrapper>
          <PageWidget mobile={mobile} desktop={isDesktop}>
            <Flex
              style={{ paddingRight: '1.2em' }}
              justifyBetween={true}
              alignCenter={true}
              row={true}
            >
              {/*<PageTitle*/}
              {/*  style={{*/}
              {/*    display: 'flex',*/}
              {/*    alignItems: 'center',*/}
              {/*  }}*/}
              {/*  size={size}*/}
              {/*  desktop={isDesktop}*/}
              {/*>*/}
              {/*<img*/}
              {/*  style={{*/}
              {/*    width: isDesktop ? '123px' : '89px',*/}
              {/*    height: isDesktop ? '38px' : '27px',*/}
              {/*  }}*/}
              {/*  src={airbnb}*/}
              {/*  alt={'airbnb'}*/}
              {/*/>*/}
              {/*{sync === IntegrationSync.NotSyncing ? (*/}
              {/*  <img*/}
              {/*    style={{*/}
              {/*      width: isDesktop ? '32px' : '24px',*/}
              {/*      height: isDesktop ? '32px' : '24px',*/}
              {/*      marginLeft: '5px',*/}
              {/*    }}*/}
              {/*    src={isDesktop ? airbnboff : airbnboffmobile}*/}
              {/*    alt={'airbnb-off'}*/}
              {/*  />*/}
              {/*) : (*/}
              {/*  <div*/}
              {/*    style={{*/}
              {/*      width: isDesktop ? '24px' : '18px',*/}
              {/*      height: isDesktop ? '24px' : '18px',*/}
              {/*      marginLeft: '5px',*/}
              {/*      display: 'inline-flex',*/}
              {/*      alignItems: 'center',*/}
              {/*      justifyContent: 'center',*/}
              {/*      backgroundColor: '#07a944',*/}
              {/*      borderRadius: '50%',*/}
              {/*    }}*/}
              {/*  >*/}
              {/*    <FaCheck color={'white'} />*/}
              {/*  </div>*/}
              {/*)}*/}
              {/*</PageTitle>*/}
              {/*{isDesktop && tab === 2 && (*/}
              {/*  <Button*/}
              {/*    style={{ minWidth: '300px', height: '40px' }}*/}
              {/*    onClick={goTo}*/}
              {/*    disabled={!sync}*/}
              {/*    isDisabled={!sync}*/}
              {/*    size={size}*/}
              {/*    primary={true}*/}
              {/*  >*/}
              {/*    {t('BBO_2913_go_to_the_calendar')}*/}
              {/*  </Button>*/}
              {/*)}*/}
              {/*{isDesktop && tab === 1 && (*/}
              {/*  <Button*/}
              {/*    style={{ minWidth: '300px', height: '40px' }}*/}
              {/*    onClick={goToSync}*/}
              {/*    disabled={noConnected}*/}
              {/*    isDisabled={noConnected}*/}
              {/*    size={size}*/}
              {/*    primary={true}*/}
              {/*  >*/}
              {/*    {t('BBO_1466_next')}*/}
              {/*  </Button>*/}
              {/*)}*/}
              {/*{isDesktop &&*/}
              {/*  checked &&*/}
              {/*  status === IntegrationStatus.NotIntegrated && (*/}
              {/*    <div>*/}
              {/*      <AirbnbButton />*/}
              {/*    </div>*/}
              {/*  )}*/}
            </Flex>
            {isSaving && loading && errMessage === '' && <Loader />}
            {isSaving && errMessage !== '' && <p>{errMessage}</p>}
            {!isSaving && (
              <>
                {checked && !loading ? (
                  <IntegrationAirbnbComponent
                    setDisableCheck={setDisableCheck}
                    mobile={mobile}
                  />
                ) : (
                  <Loader />
                )}
              </>
            )}
          </PageWidget>
        </PageWrapper>
      </React.Suspense>
    </Flex>
  )
}

export default IntegrationAirbnb

export interface IWidgetScreenProps {
  token: string
}

export interface IWidgetScreenDispatch {
  loadData: () => void
}
